import { render, staticRenderFns } from "./Rating_wrap.vue?vue&type=template&id=4634bf8c"
import script from "./Rating_wrap.vue?vue&type=script&lang=js"
export * from "./Rating_wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports